import { Typography, toast } from "@stardust-ds/react"
import { useState } from "react"
import intl from "react-intl-universal"
import Input from "../../atoms/Input"
import RcmpTextArea from "../../atoms/TextArea"
import FileInput from "../../atoms/FileInput"
import RcmpModalAdd from "../ModalAdd"
import Modal from "../Modal"
import styles from "./index.module.scss"
import * as yup from "yup"
import { useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { useEffect } from "react"
import Button from "../../atoms/Button"
import FileCard from "../../atoms/FileCard"
import { fnPostExportBoard } from "../../../services/boards"
import RcmpModalInfo from "../../organisms/ModalInfo"
import RcmpFormErrorMessage from "../../atoms/FormErrorMessage"

export default function RcmpModalExportBoard(props) {
  const {
    cTitle,
    bIsOpen,
    bOnClose,
    nCurrentBoardId,
  } = props

  const [bLoading, fnSetBLoading] = useState(false)
  const [oFiles, fnSetFiles] = useState([])
  const [bIsConfirmCloseModalOpen, fnSetBIsConfirmCloseModalOpen] = useState(false)
  const schema = yup.object().shape({
    name: yup.string().required(intl.get("form.required_field"),),
    description: yup.string().required(intl.get("form.required_field"),),
  })

  const { register, handleSubmit, reset, setError, formState: {isDirty, errors} } = useForm({
    resolver: yupResolver(schema),
    criteriaMode: "all"
  })

  const fnSumbit = async (data) => {
    try {
      fnSetBLoading(true)
      if (oFiles?.length === 0) {
        setError("file", {
          message: intl.get("form.required_field"),
        })
        fnSetBLoading(false)
        return
      }
      const formdata = new FormData()

      formdata.append("opmd_cname", data?.name)
      formdata.append("opmd_cdescription", data?.description)
      formdata.append("opmd_cimage", oFiles[0]?.opae_cvalue)

      await fnPostExportBoard(nCurrentBoardId, formdata)

      toast({
        type: "success",
        description: intl.get("board.export_board_success"),
      })
      bOnClose(true)
      reset({})
    } catch (e) {
      toast({
        type: "error",
        description: intl.get("board.export_board_error"),
      })
    } finally {
      fnSetBLoading(false)
    }
  }

  function fnCloseModal() {
    if (bLoading) return

    bOnClose(false)
  }

  function fnDeleteEvidence(index) {
    const temp = [...oFiles]
    temp.splice(index, 1)
    fnSetFiles(temp)
  }

  function fnCheckBeforeClose() {
    if (isDirty || oFiles.length > 0) {
      fnSetBIsConfirmCloseModalOpen(true)
    } else {
      fnCloseModal()
    }
  }

  useEffect(() => {
    reset({})
    fnSetFiles([])
  }, [bIsOpen])

  return (
    <>
    <Modal isOpen={bIsOpen} size="xlg">
      <Modal.Header onClose={fnCloseModal}>{cTitle}</Modal.Header>
      <form
        onSubmit={handleSubmit(fnSumbit)}
        style={{ width: "100%", padding: "2rem" }}
      >
        <Modal.Content>
          <div className={styles.container}>
            <div className={styles.row}>
              <Input
                /* required */
                isFullWidth
                label={`${intl.get("modal_form_list.name")} *`}
                placeholder={`${intl.get("type")}`}
                type="text"
                {...register("name")}
                />
                 { errors['name'] && <RcmpFormErrorMessage>{errors['name']?.message}</RcmpFormErrorMessage> }
            </div>
            <div className={styles.row}>
              <RcmpTextArea
                /* required */
                label={`${intl.get("modal_form_list.description")} *`}
                placeholder={intl.get("type")}
                {...register("description")}
                />
                { errors['description'] && <RcmpFormErrorMessage>{errors['description']?.message}</RcmpFormErrorMessage> }
            </div>
            <div className={styles.row} style={{ gap: "0.5rem" }}>
              <Typography
                color="#415364"
                type="l3"
                textAlign="left"
                mBottom="3rem !important"
              >
                Imagem*
              </Typography>
              <FileInput fnFileSubmit={(data) => fnSetFiles(data)} bOtherExtensions>
                <Typography color="#415364" type="l3" textAlign="left">
                  {intl.get("ActivityEvidence.evidence_sent")}
                </Typography>
              </FileInput>
              {oFiles.map((file, i) => (
                <FileCard
                  isForm={true}
                  key={i}
                  title={file?.opae_cfilename}
                  removeFile={() => fnDeleteEvidence(i)}
                />
              ))}
              { errors['file'] && <RcmpFormErrorMessage>{errors['file']?.message}</RcmpFormErrorMessage> }
            </div>
          </div>
        </Modal.Content>
        <Modal.Footer>
          <div className={styles.buttonFooterContainer}>
            <Button variant={"outline"} onClick={fnCheckBeforeClose} disabled={bLoading}>
              {intl.get("cancel")}
            </Button>
            <Button isLoading={bLoading}>{intl.get("board.export_board")}</Button>
          </div>
        </Modal.Footer>
      </form>
    </Modal>
    <RcmpModalInfo
        fnHandleCancel={() => fnSetBIsConfirmCloseModalOpen(false)}
        bIsOpen={bIsConfirmCloseModalOpen}
        title={intl.get("cancel")}
        buttonCancelText={intl.get("activityModelModal.close_when_change_field_cancel")}
        buttonSaveText={intl.get("activityModelModal.close_when_change_field_sure")}
        description={
          <p>
            <strong>{intl.get("activityModelModal.close_when_change_fieldA")}</strong>
            {intl.get("activityModelModal.close_when_change_fieldB")}
          </p>
        }
        fnHandleConfirm={() => {
          fnSetBIsConfirmCloseModalOpen(false)
          fnCloseModal()
        }}
        size
      />
                </>
  )
}
